/*import { useAuth } from '../components/Auth/store';
import References from './Reference';

export default class AuthService {

	static refreshPromise = null;	

	static getHeaders = ( data ) => {
		return {
			    method: "POST",
			    headers: {
			      "Content-Type": "application/json"
			    },
			    body: JSON.stringify( data ), // body data type must match "Content-Type" heade

		}
	}
	
	static async login( login, password ) {	
		const data = {
			"username": login, 
			"password": password
		};

		return fetch(
			References.api.login, 
			AuthService.getHeaders( data )
		)
		.then(response => response.json())
	}

	static async logout() {
		const data = {
			"refresh": localStorage.getItem('refresh_token')
		};

		try {
			await fetch(	
				References.api.logout, 
				AuthService.getHeaders( data )
			)
		} finally {
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
		}
	}


	static async saveTokens( access, refresh ) {
		localStorage.setItem('access_token', access);

		if (refresh)
			localStorage.setItem('refresh_token', refresh);
	}

	static isAuth() {		
		return (
			localStorage.getItem('access_token') != null && 
			localStorage.getItem('refresh_token') != null
		);
	}	

	static isForciblyAuth() {
		return this.getAccessToken()
			.then( data => {		
				return !data.hasOwnProperty('code') || data.code != 'token_not_valid';
			})
			.catch(() => {
				return false
			});		
	}

	static async refresh() {

		if (AuthService.refreshPromise) {
			return AuthService.refreshPromise;
		}		

		const data = {
			"refresh": localStorage.getItem('refresh_token')
		};

		AuthService.refreshPromise = fetch(
			References.api.refresh,
			AuthService.getHeaders(data)
		)
		.then(response => response.json())
		.then(data => {


			if (
				data.hasOwnProperty('code') &&
				data.code === 'token_not_valid'
			) {
				throw new Error('refresh_invalid');
			}

			AuthService.saveTokens(
				data.access,
				data.refresh || localStorage.getItem('refresh_token')
			);

			return data;
		})
		.finally(() => {
			AuthService.refreshPromise = null;
		});

		return AuthService.refreshPromise;	
	}

	static async check( token ) {		
		const data = {
			"token": localStorage.getItem( 'access_token' )
		};

		return fetch(
				References.api.check, 
				AuthService.getHeaders( data )
			)
		.then(response => response.json())
	}

	static async getAccessToken() {
		const access = localStorage.getItem( 'access_token' );
		const refresh = localStorage.getItem( 'refresh_token' );

		if (!access || !refresh)
			throw new Error('no_keys');			

		return this.check()
			.then( data => {
				if (
					data.hasOwnProperty('code') && 
					data.code == 'token_not_valid'
				)
					return AuthService.refresh();
				else {
					return {
						"access": access
					}
				}
			});
	}

	static async fetch( url ) {
		return this.getAccessToken()
			.then( data => {	
					if (data.hasOwnProperty('access'))
						AuthService.saveTokens( data.access, localStorage.getItem('refresh_token') );

					return fetch( url, {
						"headers": {						
							"Authorization": "Bearer " + data.access
						}
					});
				}
			)
			.catch(_ => useAuth.setState({isAuth: false}))
	}

	static async fetchAll( urls ) {
		return this.getAccessToken()
			.then( data => {	
					if (data.hasOwnProperty('access'))
						AuthService.saveTokens( data.access, localStorage.getItem('refresh_token') );

					return Promise.all(urls.map(url => fetch(url, {
						"headers": {						
							"Authorization": "Bearer " + data.access
						}
					})))
				}
			)
			.catch(_ => useAuth.setState({isAuth: false}))
	}	

	static async post( url, params ) {
		return this.getAccessToken()
			.then( data => {	
					if (data.hasOwnProperty('access'))
						AuthService.saveTokens( data.access, localStorage.getItem('refresh_token') );

					return fetch( url, {
						"headers": {						
							"Authorization": "Bearer " + data.access,
							"Content-Type": "application/json"
						},
						"method": "POST",
						"body": JSON.stringify(params)
					});
				}
			)
			.catch(_ => useAuth.setState({isAuth: false}))
	}  
}*/

import { useAuth } from '../components/Auth/store';
import References from './Reference';

export default class AuthService {

	static refreshPromise = null;

	// =========================
	// TOKEN STORAGE
	// =========================

	static getAccessToken() {
		return localStorage.getItem('access_token');
	}

	static getRefreshToken() {
		return localStorage.getItem('refresh_token');
	}

	static saveTokens(access, refresh = null) {

		if (access)
			localStorage.setItem('access_token', access);

		if (refresh)
			localStorage.setItem('refresh_token', refresh);
	}

	static clearTokens() {
		localStorage.removeItem('access_token');
		localStorage.removeItem('refresh_token');
	}

	static isAuth() {
		return !!(
			this.getAccessToken() &&
			this.getRefreshToken()
		);
	}

	static async isForciblyAuth() {
		try {   
			const refresh = this.getRefreshToken();
	
			if (!refresh)
				return false;
	
			await this.refresh();
	
			return true;
	
		} catch {
	
			this.clearTokens();
	
			return false;
		}
	}    

	// =========================
	// LOGIN
	// =========================


    static async login(username, password) {

        const response = await fetch(
            References.api.login,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    username,
                    password
                })
            }
        );

        if (!response.ok)
            throw new Error("LOGIN_FAILED");

        const data = await response.json();

        this.saveTokens(
            data.access,
            data.refresh
        );

        useAuth.setState({
            isAuth: true
        });

        return data;
    }
	// =========================
	// LOGOUT
	// =========================

    static async logout() {

        try {

            const refresh = this.getRefreshToken();

            if (refresh) {

                await fetch(
                    References.api.logout,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            refresh
                        })
                    }
                );
            }

        } finally {

            this.unauthorized();
        }
    }


	// =========================
	// REFRESH
	// =========================

    static async refresh() {

        if (this.refreshPromise)
            return this.refreshPromise;

        const promise = (async () => {

            const refresh = this.getRefreshToken();

            if (!refresh)
                throw new Error("NO_REFRESH");

            const response = await fetch(
                References.api.refresh,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        refresh
                    })
                }
            );

            if (response.status === 401)
                throw new Error("REFRESH_EXPIRED");

            if (!response.ok)
                throw new Error("NETWORK");

            const data = await response.json();

            if (data.code === "token_not_valid")
                throw new Error("REFRESH_EXPIRED");

            this.saveTokens(
                data.access,
                data.refresh
            );

            return data.access;

        })();

        this.refreshPromise = promise;

        try {

            return await promise;

        } finally {

            if (this.refreshPromise === promise)
                this.refreshPromise = null;
        }
    }

	// =========================
	// AUTHORIZED REQUEST
	// =========================


    static async request(
        url,
        options = {}
    ) {

        const send = () => {

            const access = this.getAccessToken();

            if (!access)
                throw new Error("NO_ACCESS");

            return fetch(
                url,
                {
                    ...options,
                    headers: {
                        ...(options.headers ?? {}),
                        Authorization: `Bearer ${access}`
                    }
                }
            );
        };

        let response = await send();

        if (response.status !== 401)
            return response;

        try {

            await this.refresh();

        } catch (error) {

            if (
                error.message === "NO_REFRESH" ||
                error.message === "REFRESH_EXPIRED"
            ) {

                this.unauthorized();
            }

            throw error;
        }

        return send();
    }


	static async fetch(url) {

		return this.request(
			url,
			{
				method: 'GET'
			}
		);
	}

	static async fetchAll(urls = []) {

		return Promise.all(
	
			urls.map(url =>
	
				this.request(
					url,
					{
						method: 'GET'
					}
				)
			)
		);
	}    

	static async post(
		url,
		body = {}
	) {

		return this.request(
			url,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(body)
			}
		);
	}

}

